import script from "./RequestOrgRegist.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestOrgRegist.vue?vue&type=script&setup=true&lang=ts"

import "./RequestOrgRegist.vue?vue&type=style&index=0&id=53217e89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53217e89"]])

export default __exports__